import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const BookingChargesTable = () => {
  const headers = [
    "Persons Capacity",
    "Surahi Hall 1st Floor",
    "Small Party Hall 1st Floor",
    "Rose Garden",
    "Fountain Lawn",
    "Hall Near Fountain"
  ];

  const data = [
    ["Up to 25 Persons", "4000/-", "2500/-", "2500/-", "2500/-", "2500/-"],
    ["26-30 Person", "4000/-", "3000/-", "3000/-", "3000/-", "N.A."],
    ["31-40 Persons", "4000/-", "N.A.", "4000/-", "4000/-", "N.A."],
    ["41-50 Persons", "5000/-", "N.A.", "5000/-", "5000/-", "N.A."],
    ["51-70 Persons", "7000/-", "N.A.", "N.A.", "N.A.", "N.A."],
    ["71-100 Persons", "N.A.", "N.A.", "N.A.", "N.A.", "N.A."],
    ["101-150 Person", "N.A.", "N.A.", "N.A.", "N.A.", "N.A."]
  ];

  const notes = [
    "1. Family Hall Booking up to 5:00 PM",
    "2. Kitty Party only Members (1000/- SMALL PARTY HALL 1ST FLOOR & 1500/- SURAHI HALL)",
    "3. ALL Charges including GST."
  ];

  return (
    <div className="container ">
      <h4 className="text-center ">Booking Charges for Party Hall, Small Lawns </h4>
      <div className="table-responsive">
        <table className="table table-bordered table-striped text-center align-middle">
          <thead className="table-dark">
            <tr>
              {headers.map((head, idx) => (
                <th key={idx}>{head}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                {row.map((cell, cIdx) => (
                  <td key={cIdx}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-3 row">
        <div className="col-10">
        {notes.map((note, idx) => (
          <p key={idx} className="mb-1 "><strong>Note:</strong> {note}</p>
        ))}
        </div>

      </div>
    </div>
  );
};

export default BookingChargesTable;
